import { Controller } from "@hotwired/stimulus"
import { nameError } from "../modules/sections_list.mjs"

// Fila de Secciones del menú: avisa a la lista (mover, acciones), renombra en línea y abre el
// panel "Ver productos" (Turbo Frame perezoso). Doc: _docs/frontend/catalog_presentation/partner_sections.md → Cliente
export default class extends Controller {
  static targets = ["form", "input", "hint", "save", "products", "productsToggle"]

  up() {
    this.#move(-1)
  }

  down() {
    this.#move(1)
  }

  actions() {
    this.dispatch("actions", { detail: { row: this.element } })
  }

  // "Se ve como" (mobile): la hoja de vista
  layout() {
    this.dispatch("layout", { detail: { row: this.element } })
  }

  // ---- Renombrar ----

  edit() {
    this.element.classList.add("is-editing")
    this.formTarget.hidden = false
    this.inputTarget.value = this.element.dataset.sectionName
    this.#showError(null)
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.formTarget.hidden = true
    this.element.classList.remove("is-editing")
    this.inputTarget.value = this.element.dataset.sectionName
    this.#showError(null)
  }

  // Al escribir avisa el repetido; el vacío, al intentar guardar (guardSave)
  validate() {
    this.#showError(this.inputTarget.value.trim() === "" ? null : this.#error())
  }

  guardSave(event) {
    const error = this.#error()
    if (!error) return
    event.preventDefault()
    this.#showError(error)
    this.inputTarget.focus()
  }

  // turbo:submit-end: con éxito el stream reemplaza la fila; con 422 el campo sigue abierto
  saved(event) {
    if (!event.detail.success) this.inputTarget.focus()
  }

  // ---- Ver productos ----

  toggleProducts() {
    this.#setProducts(this.productsTarget.hidden)
  }

  // Desde la hoja (mobile)
  showProducts() {
    this.#setProducts(true)
    this.element.scrollIntoView({ block: "nearest" })
  }

  // turbo:before-cache: el panel no viaja abierto al snapshot
  collapse() {
    if (this.hasProductsTarget) this.#setProducts(false)
  }

  #setProducts(open) {
    if (!this.hasProductsTarget) return
    this.productsTarget.hidden = !open
    this.element.classList.toggle("is-expanded", open)
    this.productsToggleTargets.forEach(toggle => {
      toggle.setAttribute("aria-expanded", String(open))
      toggle.textContent = open ? "Ocultar productos" : "Ver productos"
    })
  }

  #move(delta) {
    this.dispatch("move", { detail: { id: this.element.dataset.sectionId, delta } })
  }

  #error() {
    return nameError(this.inputTarget.value, this.#names(), this.element.dataset.sectionName)
  }

  #names() {
    return Array.from(this.element.parentElement.querySelectorAll(":scope > [data-section-id]")).map(row => row.dataset.sectionName)
  }

  #showError(error) {
    this.hintTarget.textContent = error ?? ""
    this.hintTarget.hidden = !error
    this.inputTarget.setAttribute("aria-invalid", String(Boolean(error)))
    this.saveTarget.setAttribute("aria-disabled", String(Boolean(error)))
  }
}
